import { m } from '$lib/paraglide/messages.js'

export type AccountDeletionText = {
    body: string
    cancel: string
    close: string
    codeInvalid: string
    codeLabel: string
    codeRequired: string
    confirmDelete: string
    confirmationDescription: string
    confirmationTitle: string
    deleteFailed: string
    oneTimeCode: string
    manualRemovalBrowser: string
    manualRemovalClose: string
    manualRemovalNativeWrapper: string
    manualRemovalTitle: string
    requestButton: string
    requestFailed: string
    resendCode: string
    title: string
    verificationDescription: string
    verify: string
}

export function getAccountDeletionText(): AccountDeletionText {
    return {
        body: [m.delete_account_body_intro(), m.delete_account_body_email_directions()].join(
            '\n\n'
        ),
        cancel: m.delete_account_cancel(),
        close: m.delete_account_close(),
        codeInvalid: m.delete_account_code_invalid(),
        codeLabel: m.delete_account_code_label(),
        codeRequired: m.delete_account_code_required(),
        confirmDelete: m.delete_account_confirm_delete(),
        confirmationDescription: m.delete_account_confirmation_description(),
        confirmationTitle: m.delete_account_confirm_title(),
        deleteFailed: m.delete_account_delete_failed(),
        oneTimeCode: m.delete_account_one_time_code_title(),
        manualRemovalBrowser: m.delete_account_manual_removal_browser(),
        manualRemovalClose: m.delete_account_manual_removal_close(),
        manualRemovalNativeWrapper: m.delete_account_manual_removal_native_wrapper(),
        manualRemovalTitle: m.delete_account_manual_removal_title(),
        requestButton: m.delete_account_request_button(),
        requestFailed: m.delete_account_request_failed(),
        resendCode: m.delete_account_resend_code(),
        title: m.shell_my_account_delete_account(),
        verificationDescription: m.delete_account_verification_description(),
        verify: m.delete_account_verify()
    }
}
